// totalStep="1" (질문 1개)- 1.이름&번호
// totalStep="2" (질문 2개)- 1.임플란트 갯수, 2.이름&번호
// numberColor - #0854fc(밝은 파란색),#0824a4(남색), #3f8c58(짙은 녹색),#18646c(청록색)
// qOptionColor - blue, green, teal

import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import { validateName, validatePhoneNumber } from "../utils/validation";
import {
  options,
  options3,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import SelectCountry from "../components/SelectCountry";
import PrivacyContent from "./PrivacyContent";

function RandingStyle19({
  urlCode,
  urlCodeSettingId,
  totalStep,
  changedIMG,
  img1Path,
  img2Path,
  img3Path,
  numberColor,
  qOptionColor,
  qOptionColor2,
  qTitleColor,
  formFieldColor,
  audioOn,
  passBTN,
  keepBTN,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  articleOption,
  articleOptionColor,
  randingNumber,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  eventsOption,
  treatments,
  countries,
  privacyMessage,
  addStyle,
  kakaotalk,
  carrotTag,
  allCountry, //전지점
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";

  // 상태 관리.
  const [selectedValue, setSelectedValue] = useState(null); // 선택된 값을 저장할 상태

  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });

  const [selectedOption, setSelectedOption] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option, group) => {
    setSelectedOption((prev) => {
      const optionsArray = prev ? prev.split(",") : ["", ""]; // 위쪽과 아래쪽 옵션을 각각 관리
      if (group === "top") {
        // 위쪽 옵션 선택
        optionsArray[0] = option; // 첫 번째 그룹에 선택된 옵션 저장
      } else if (group === "bottom") {
        // 아래쪽 옵션 선택
        optionsArray[1] = option; // 두 번째 그룹에 선택된 옵션 저장
      }
      return optionsArray.join(","); // 콤마로 연결된 문자열 반환
    });
    console.log("Selected options:", selectedOption);
  };

  const nextStep = () => {
    if (currentStep < totalStep) {
      setCurrentStep(currentStep + 1); // 다음 단계로 이동
    } else {
      handleSubmit(); // 마지막 단계에서는 폼 제출
    }
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    if (allCountry && (!selectedOption || selectedOption.trim() === "")) {
      alert("가까운 지역을 선택해주세요."); // 사용자에게 알림
      return;
    }
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      // 이벤트 복수 세팅
      selectedValue,
      kakaotalk,
      carrotTag,
    });
  };
  console.log(currentStep);

  const audioRef = useRef(null);

  const handlePlayAudio = () => {
    const audio = audioRef.current;
    if (audio && currentStep === 1) {
      audio.currentTime = 0; // ✅ 0초로 설정 (처음부터 재생)
      audio.muted = false;
      audio.volume = 1;
      audio.play().catch((err) => {
        console.warn("재생 실패:", err);
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      handlePlayAudio();
      window.removeEventListener("scroll", handleScroll);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentStep]);

  return (
    <div className="form-container" onClick={handlePlayAudio}>
      <audio
        ref={audioRef}
        autoPlay
        muted
        loop={false}
        src={`${process.env.REACT_APP_CDN_BASE}/images/${randingNumber}/audio${randingNumber}-${currentStep}.mp3`}
        style={{ display: "none" }}
      />

      {currentStep === 1 && (
        <div className="step1" style={{ position: "relative" }}>
          <img src={img1Path} alt="임플란트 고민중이세요?" />
          <div
            className="sendBtnBox"
            style={{
              position: "absolute",
              bottom: "10px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            <img src={passBTN} alt="계속하기" onClick={nextStep} />
          </div>
        </div>
      )}

      {currentStep === 2 && (
        <div className="step1" style={{ position: "relative" }}>
          <img src={img2Path} alt="임플란트 고민중이세요?" />

          {allCountry ? (
            <>
              <div className="qBox">
                <form
                  className="formBox"
                  onSubmit={(e) => {
                    e.preventDefault(); // 기본 제출 동작 방지
                    handleSubmit(); // 기존 handleSubmit 호출
                  }}
                >
                  <div className="qTitleSmall">
                    <span style={{ color: qTitleColor, margin: "20px" }}>
                      Q1.
                    </span>
                    <p>가까운 지역을 선택하세요</p>
                  </div>
                  <SelectCountry
                    selectCountry={selectedOption}
                    setSelectCountry={setSelectedOption}
                    countries={countries}
                    propswidth="85%" // 선택적으로 너비 지정
                  />

                  <div className="qTitleSmall">
                    <span style={{ color: qTitleColor, margin: "20px" }}>
                      Q2.
                    </span>
                    <p>이름과 연락처를 적어주세요</p>
                  </div>
                  <div className="qBox">
                    {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}{" "}
                    {/* 전송폼 세분화 */}
                    <div
                      className={`formField ${
                        formFieldColor === "white" ? "white" : ""
                      }`}
                    >
                      <label htmlFor="name">이름</label>
                      <input
                        type="text"
                        id="name"
                        maxLength="10"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="이름을 입력해주세요."
                      />
                    </div>
                    <PhoneNumberInput
                      phoneNumber={phoneNumber}
                      phoneFirstOptions={phoneFirstOptions}
                      handlePhoneNumberChange={handlePhoneNumberChange}
                      formFieldColor={formFieldColor}
                    />
                    <p className="benefitInfo">
                      <BenefitPeriod />
                      <br />
                      이벤트 대상자 : 해당 매체 이용자
                    </p>
                    <PrivacyPolicyAgree
                      isAgreed={isAgreed}
                      setIsAgreed={setIsAgreed}
                      togglePrivacyPolicyModal={togglePrivacyPolicyModal}
                      privacyMessage={privacyMessage}
                    />
                    {isPrivacyPolicyModal && (
                      <div
                        className="modalOverlay"
                        onClick={togglePrivacyPolicyModal}
                      >
                        <div
                          className="privacyPolicyContent"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <PrivacyContent companyName={privacyName} />
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="sendBtnBox"
                    disabled={isSubmitting}
                  >
                    <img src={postBTN} alt="신청하기" />
                  </button>
                </form>
              </div>
            </>
          ) : (
            <div
              className="qBox"
              style={{
                position: "absolute",
                top: "23%",
              }}
            >
              <div className="qTitleSmall">
                <span style={{ color: qTitleColor, margin: "20px" }}>Q1.</span>
                <p>임플란트 필요한 개수는?</p>
              </div>
              <div
                className="qOptions row"
                style={{ transform: " translateX(0%)" }}
              >
                {options
                  .filter((option) => option !== "상담필요")
                  .map((option, index) => (
                    <img
                      style={{ width: "32%" }}
                      key={index}
                      src={`${process.env.REACT_APP_CDN_BASE}/images/qOptions/radio/${
                        selectedOption.split(",")[0] === option
                          ? `${qOptionColor || "blue"}/qoption${index + 1}(1)`
                          : `qoption${index + 1}`
                      }.png`}
                      alt={option}
                      onClick={() => handleSelectImplant(option, "top")} // 'top' 옵션 선택
                    />
                  ))}
              </div>
              <div className="qTitleSmall">
                <span
                  style={{ color: qTitleColor, margin: "0 10px 10px 10px" }}
                >
                  Q2.
                </span>
                <p>연령대를 선택해주세요</p>
              </div>
              <div
                className="qOptions row"
                style={{ transform: " translateX(0%)" }}
              >
                {options3
                  .filter((option) => option !== "상담필요")
                  .map((option, index) => (
                    <img
                      style={{ width: "32%" }}
                      key={index}
                      src={`${process.env.REACT_APP_CDN_BASE}/images/qOptions/radio/${
                        selectedOption.split(",")[1] === option
                          ? `${qOptionColor2 || "blue"}/ageoption${
                              index + 1
                            }(1)`
                          : `ageoption${index + 1}`
                      }.png`}
                      alt={option}
                      onClick={() => handleSelectImplant(option, "bottom")} // 'bottom' 옵션 선택
                    />
                  ))}
              </div>
              <div className="sendBtnBox">
                <img src={keepBTN} alt="계속하기" onClick={nextStep} />
              </div>
            </div>
          )}
        </div>
      )}

      {currentStep === 3 && (
        <div className="step2">
          <img src={img3Path} alt="임플란트 고민중이세요?" />
          <div className="qBox">
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            <form
              className="formBox"
              onSubmit={(e) => {
                e.preventDefault(); // 기본 제출 동작 방지
                handleSubmit(); // 기존 handleSubmit 호출
              }}
            >
              <div
                className={`formField ${
                  formFieldColor === "white" ? "white" : ""
                }`}
              >
                <label htmlFor="name">이름</label>
                <input
                  type="text"
                  id="name"
                  maxLength="10"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="이름을 입력해주세요."
                />
              </div>
              <PhoneNumberInput
                phoneNumber={phoneNumber}
                phoneFirstOptions={phoneFirstOptions}
                handlePhoneNumberChange={handlePhoneNumberChange}
                formFieldColor={formFieldColor}
              />
              <p className="benefitInfo">
                <BenefitPeriod />
                <br />
                이벤트 대상자 : 해당 매체 이용자
              </p>
              <PrivacyPolicyAgree
                isAgreed={isAgreed}
                setIsAgreed={setIsAgreed}
                togglePrivacyPolicyModal={togglePrivacyPolicyModal}
                privacyMessage={privacyMessage}
              />
              {isPrivacyPolicyModal && (
                <div
                  className="modalOverlay"
                  onClick={togglePrivacyPolicyModal}
                >
                  <div
                    className="privacyPolicyContent"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <PrivacyContent companyName={privacyName} />
                  </div>
                </div>
              )}
              <button
                type="submit"
                className="sendBtnBox"
                disabled={isSubmitting}
              >
                <img src={postBTN} alt="신청하기" />
              </button>
            </form>
          </div>
        </div>
      )}
      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </div>
  );
}

export default RandingStyle19;
